export default {
  data () {
    return {
      logoUrlQueryParams: {}
    }
  },
  mounted () {
    if (this.$route.query.law_firm_id !== undefined) {
      this.logoUrlQueryParams.law_firm_id = this.$route.query.law_firm_id
    }
  }
}
